import { useEffect, useState } from "react";
import { MdKey, MdPeople, MdDevices, MdWarning, MdInventory, MdNotificationsActive } from "react-icons/md";
import Widget from "components/widget/Widget";
import { api } from "api";

const Dashboard = () => {
  const [stats, setStats] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [pushInfo, setPushInfo] = useState<any>(null);
  const [pushLoading, setPushLoading] = useState(false);
  const [pushMsg, setPushMsg] = useState("");

  useEffect(() => {
    api.getStats().then(setStats).catch(console.error).finally(() => setLoading(false));
    api.pushDebug().then(setPushInfo).catch(() => setPushInfo({ total_tokens: 0, active_tokens: 0, recent: [] }));
  }, []);

  const [pushErrors, setPushErrors] = useState<any[]>([]);
  const sendTestPush = async () => {
    setPushLoading(true);
    setPushMsg("");
    setPushErrors([]);
    try {
      const r = await api.pushTest();
      setPushMsg(`Sonuc: ${r.sent} gonderildi, ${r.failed} basarisiz, ${r.deactivated} olu token`);
      setPushErrors(r.errors || []);
      // Token listesi guncel kalsin
      const d = await api.pushDebug();
      setPushInfo(d);
    } catch (e: any) {
      setPushMsg("Hata: " + e.message);
    } finally {
      setPushLoading(false);
    }
  };

  const sendVergiPush = async (when: "today" | "tomorrow" | "both") => {
    setPushLoading(true);
    setPushMsg("");
    setPushErrors([]);
    try {
      const r: any = await api.pushVergiTakvimi(when);
      const parts: string[] = [];
      if (r.today) {
        parts.push(`Bugün (${r.today.date}): ${r.today.count} kayıt — gönderim: ${r.today.push?.sent ?? 0} başarılı / ${r.today.push?.failed ?? 0} hata`);
      }
      if (r.tomorrow) {
        parts.push(`Yarın (${r.tomorrow.date}): ${r.tomorrow.count} kayıt — gönderim: ${r.tomorrow.push?.sent ?? 0} başarılı / ${r.tomorrow.push?.failed ?? 0} hata`);
      }
      setPushMsg(parts.join("\n") || "Bugün/Yarın için kayıt yok");
    } catch (e: any) {
      setPushMsg("Hata: " + e.message);
    } finally {
      setPushLoading(false);
    }
  };

  if (loading) return <div className="mt-10 text-center text-gray-500">Yukleniyor...</div>;
  if (!stats) return <div className="mt-10 text-center text-red-500">Veriler yuklenemedi</div>;

  return (
    <div>
      <div className="mt-3 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-5">
        <Widget icon={<MdPeople className="h-7 w-7" />} title="Toplam Kullanici" subtitle={String(stats.total_users)} />
        <Widget icon={<MdKey className="h-7 w-7" />} title="Aktif Lisanslar" subtitle={String(stats.active_licenses)} />
        <Widget icon={<MdWarning className="h-6 w-6" />} title="Suresi Dolan" subtitle={String(stats.expired_licenses)} />
        <Widget icon={<MdInventory className="h-6 w-6" />} title="Atanmamis" subtitle={String(stats.unassigned_licenses)} />
        <Widget icon={<MdDevices className="h-7 w-7" />} title="Toplam Cihaz" subtitle={String(stats.total_devices)} />
      </div>

      <div className="mt-5 grid grid-cols-1 gap-5 xl:grid-cols-2">
        <div className="rounded-[20px] bg-white p-6 shadow-3xl shadow-shadow-500 dark:!bg-navy-800 dark:shadow-none">
          <h4 className="text-lg font-bold text-navy-700 dark:text-white mb-4">Hizli Islemler</h4>
          <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
            <a href="/admin/licenses" className="flex items-center gap-3 rounded-xl bg-lightPrimary p-4 hover:bg-gray-100 dark:bg-navy-700 dark:hover:bg-navy-600 transition">
              <MdKey className="h-8 w-8 text-brand-500" />
              <div>
                <p className="font-bold text-navy-700 dark:text-white">Lisans Olustur</p>
                <p className="text-sm text-gray-600">Yeni lisans key uret</p>
              </div>
            </a>
            <a href="/admin/users" className="flex items-center gap-3 rounded-xl bg-lightPrimary p-4 hover:bg-gray-100 dark:bg-navy-700 dark:hover:bg-navy-600 transition">
              <MdPeople className="h-8 w-8 text-brand-500" />
              <div>
                <p className="font-bold text-navy-700 dark:text-white">Kullanicilar</p>
                <p className="text-sm text-gray-600">Kullanici yonetimi</p>
              </div>
            </a>
          </div>
        </div>

        <div className="rounded-[20px] bg-white p-6 shadow-3xl shadow-shadow-500 dark:!bg-navy-800 dark:shadow-none">
          <h4 className="text-lg font-bold text-navy-700 dark:text-white mb-4">Sistem Durumu</h4>
          <div className="space-y-3">
            <div className="flex justify-between"><span className="text-gray-600">API Durumu</span><span className="font-bold text-green-500">Aktif</span></div>
            <div className="flex justify-between"><span className="text-gray-600">Veritabani</span><span className="font-bold text-green-500">Bagli</span></div>
            <div className="flex justify-between"><span className="text-gray-600">Tarih</span><span className="font-bold text-navy-700 dark:text-white">{new Date().toLocaleDateString("tr-TR")}</span></div>
          </div>
        </div>
      </div>

      {/* Push Notification Debug */}
      <div className="mt-5 rounded-[20px] bg-white p-6 shadow-3xl shadow-shadow-500 dark:!bg-navy-800 dark:shadow-none">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-2">
            <MdNotificationsActive className="h-6 w-6 text-brand-500" />
            <h4 className="text-lg font-bold text-navy-700 dark:text-white">Push Bildirim Sistemi</h4>
          </div>
          <div className="flex flex-wrap gap-2">
            <button
              onClick={() => sendVergiPush("today")}
              disabled={pushLoading || !pushInfo || pushInfo.active_tokens === 0}
              className="rounded-xl bg-orange-500 px-4 py-2 text-sm font-medium text-white hover:bg-orange-600 disabled:opacity-50"
            >
              Bugünün Beyanları
            </button>
            <button
              onClick={() => sendVergiPush("tomorrow")}
              disabled={pushLoading || !pushInfo || pushInfo.active_tokens === 0}
              className="rounded-xl bg-purple-500 px-4 py-2 text-sm font-medium text-white hover:bg-purple-600 disabled:opacity-50"
            >
              Yarının Beyanları
            </button>
            <button
              onClick={sendTestPush}
              disabled={pushLoading || !pushInfo || pushInfo.active_tokens === 0}
              className="rounded-xl bg-brand-500 px-4 py-2 text-sm font-medium text-white hover:bg-brand-600 disabled:opacity-50"
            >
              {pushLoading ? "Gönderiliyor..." : "Test Push"}
            </button>
          </div>
        </div>

        {pushInfo ? (
          <>
            <div className="grid grid-cols-2 gap-4 mb-4">
              <div className="rounded-xl bg-gray-50 p-4 dark:bg-navy-700">
                <p className="text-xs text-gray-500">Toplam Kayitli Cihaz</p>
                <p className="text-2xl font-bold text-navy-700 dark:text-white">{pushInfo.total_tokens}</p>
              </div>
              <div className="rounded-xl bg-green-50 p-4 dark:bg-green-900/20">
                <p className="text-xs text-gray-500">Aktif (Push Alabilen)</p>
                <p className="text-2xl font-bold text-green-600">{pushInfo.active_tokens}</p>
              </div>
            </div>

            {pushInfo.active_tokens === 0 && (
              <div className="rounded-xl bg-orange-50 p-3 text-sm text-orange-700 mb-3 dark:bg-orange-900/20 dark:text-orange-300">
                ⚠ Aktif token yok. Mobil uygulamadan <strong>Ayarlar → BILDIRIMLER</strong> toggle aktif edilmeli ve iOS izni verilmeli.
              </div>
            )}

            {pushMsg && (
              <div className="rounded-xl bg-blue-50 p-3 text-sm text-blue-700 mb-3 dark:bg-blue-900/20 dark:text-blue-300 whitespace-pre-line">
                {pushMsg}
              </div>
            )}

            {pushErrors.length > 0 && (
              <div className="rounded-xl bg-red-50 p-3 mb-3 dark:bg-red-900/20">
                <p className="text-sm font-bold text-red-700 mb-2">Hata Detayları:</p>
                <div className="space-y-1.5">
                  {pushErrors.map((err: any, i: number) => (
                    <div key={i} className="text-xs text-red-700 dark:text-red-300 font-mono whitespace-pre-wrap">
                      {JSON.stringify(err, null, 2)}
                    </div>
                  ))}
                </div>
              </div>
            )}

            {pushInfo.recent && pushInfo.recent.length > 0 && (
              <div>
                <p className="text-sm font-medium text-gray-600 mb-2">Son Kayitli Cihazlar:</p>
                <div className="space-y-2">
                  {pushInfo.recent.map((t: any) => (
                    <div key={t.id} className="flex items-center justify-between gap-2 rounded-lg border border-gray-100 p-2.5 text-xs dark:border-navy-600">
                      <div className="flex-1 min-w-0">
                        <p className="font-mono truncate">{t.token_preview}</p>
                        <p className="text-gray-400">User ID: {t.user_id} · {t.platform} · {t.created_at?.slice(0, 16)}</p>
                      </div>
                      <span className={`rounded-full px-2 py-0.5 ${t.is_active ? "bg-green-100 text-green-700" : "bg-gray-100 text-gray-500"}`}>
                        {t.is_active ? "Aktif" : "Pasif"}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </>
        ) : (
          <p className="text-sm text-gray-500">Yukleniyor...</p>
        )}
      </div>
    </div>
  );
};

export default Dashboard;
